"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processCutData = void 0;

var process_models_1 = require("./process.models");

exports.processCutData = new Map();
var standardFields = [{
  processing: true
}, {
  finish: true
}, {
  length: true
}, {
  tolerance: true
}]; // BEGIN UTILITY MAP DATA

/*
    BEGIN STEEL DATA
*/
// No productShape Required

exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.SHEET].join(""), [{
  processing: true
}, {
  width: true
}, {
  length: true
}, {
  tolerance: true
}]);
exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.BAR, process_models_1.ProductShape.FLAT].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.BAR, process_models_1.ProductShape.HEXAGON].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.BAR, process_models_1.ProductShape.REINFORCING].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.BAR, process_models_1.ProductShape.ROUND].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.BAR, process_models_1.ProductShape.SQUARE].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.EXPANDED, process_models_1.ProductShape.FLATTENED].join(""), []);
exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.FLOORING, process_models_1.ProductShape.BAR_GRATING].join(""), []);
exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.PIPE, process_models_1.ProductShape.ROUND].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.STRUCTURAL, process_models_1.ProductShape.ANGLE].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.STRUCTURAL, process_models_1.ProductShape.BEAM].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.STRUCTURAL, process_models_1.ProductShape.CHANNEL].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.STRUCTURAL, process_models_1.ProductShape.TEE].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.TREAD_PLATE, process_models_1.ProductShape.MEDIUM_PATTERN].join(""), [].concat(standardFields, [{
  width: true
}]));
exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.TUBE, process_models_1.ProductShape.RECTANGLE].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.TUBE, process_models_1.ProductShape.ROUND].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.TUBE, process_models_1.ProductShape.SQUARE].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.COIL].join(""), [].concat(standardFields, [{
  width: true
}]));
exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.SHEET].join(""), [{
  processing: true
}, {
  width: true
}, {
  length: true
}, {
  tolerance: true
}]); // No productShape required

exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.COIL, process_models_1.CutShape.RECTANGLE].join(""), [].concat(standardFields, [{
  width: true
}]));
exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.SHEET, process_models_1.CutShape.RECTANGLE].join(""), [{
  processing: true
}, {
  width: true
}, {
  length: true
}, {
  tolerance: true
}]);
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.BAR, process_models_1.ProductShape.SQUARE].join(""), [].concat(standardFields)); // No productShape Required

exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.PLATE].join(""), [{
  cutShape: true
}, {
  processing: true
}, {
  finish: true
}]); // No productShape Required

exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.PLATE, process_models_1.CutShape.RING].join(""), [{
  cutShape: true
}, {
  processing: true
}, {
  finish: true
}, {
  outsideDiameter: true
}, {
  outsideTolerance: true
}, {
  insideDiameter: true
}, {
  insideTolerance: true
}]); // No productShape Required

exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.PLATE, process_models_1.CutShape.CIRCLE].join(""), [{
  cutShape: true
}, {
  processing: true
}, {
  finish: true
}, {
  outsideDiameter: true
}, {
  outsideTolerance: true
}]); // No productShape Required

exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.PLATE, process_models_1.CutShape.RECTANGLE].join(""), [{
  cutShape: true
}, {
  processing: true
}, {
  finish: true
}, {
  width: true
}, {
  length: true
}, {
  widthLengthTolerance: true
}]); // No productShape Required

exports.processCutData.set([process_models_1.Product.STEEL, process_models_1.Form.PLATE, process_models_1.CutShape.SQUARE].join(""), [{
  cutShape: true
}, {
  processing: true
}, {
  finish: true
}, {
  oneSide: true
}, {
  oneSideTolerance: true
}]);
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.PLATE].join(""), [{
  cutShape: true
}, {
  processing: true
}, {
  finish: true
}]);
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.BAR, process_models_1.ProductShape.FLAT].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.BAR, process_models_1.ProductShape.HEXAGON].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.BAR, process_models_1.ProductShape.ROUND].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.BAR, process_models_1.ProductShape.SQUARE].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.BAR, process_models_1.ProductShape.THREADED_ROD].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.EXPANDED, process_models_1.ProductShape.FLATTENED].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.PIPE, process_models_1.ProductShape.ROUND].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.STRUCTURAL, process_models_1.ProductShape.ANGLE].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.STRUCTURAL, process_models_1.ProductShape.BEAM].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.STRUCTURAL, process_models_1.ProductShape.CHANNEL].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.TREAD_PLATE, process_models_1.ProductShape.DIAMOND].join(""), [].concat(standardFields, [{
  width: true
}]));
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.TREAD_PLATE, process_models_1.ProductShape.MEDIUM_PATTERN].join(""), [].concat(standardFields, [{
  width: true
}]));
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.TUBE, process_models_1.ProductShape.RECTANGLE].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.TUBE, process_models_1.ProductShape.ROUND].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.TUBE, process_models_1.ProductShape.SQUARE].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.SHEET].join(""), [{
  processing: true
}, {
  width: true
}, {
  length: true
}, {
  tolerance: true
}]);
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.SHEET, process_models_1.CutShape.RECTANGLE].join(""), [{
  processing: true
}, {
  width: true
}, {
  length: true
}, {
  tolerance: true
}]);
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.PLATE, process_models_1.CutShape.RECTANGLE].join(""), [{
  cutShape: true
}, {
  processing: true
}, {
  finish: true
}, {
  width: true
}, {
  length: true
}, {
  widthLengthTolerance: true
}]);
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.PLATE, process_models_1.CutShape.CIRCLE].join(""), [{
  cutShape: true
}, {
  processing: true
}, {
  finish: true
}, {
  outsideDiameter: true
}, {
  outsideTolerance: true
}]);
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.PLATE, process_models_1.CutShape.RING].join(""), [{
  cutShape: true
}, {
  processing: true
}, {
  finish: true
}, {
  outsideDiameter: true
}, {
  outsideTolerance: true
}, {
  insideDiameter: true
}, {
  insideTolerance: true
}]);
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.PLATE, process_models_1.CutShape.SQUARE].join(""), [{
  cutShape: true
}, {
  processing: true
}, {
  finish: true
}, {
  oneSide: true
}, {
  oneSideTolerance: true
}]);
exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.COIL].join(""), [].concat(standardFields, [{
  width: true
}])); // No productShape required

exports.processCutData.set([process_models_1.Product.STAINLESS, process_models_1.Form.COIL, process_models_1.CutShape.RECTANGLE].join(""), [].concat(standardFields, [{
  width: true
}]));
/*
    BEGIN ALUMINUM DATA
 */

exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.SHEET].join(""), [{
  processing: true
}, {
  width: true
}, {
  length: true
}, {
  tolerance: true
}]);
exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.COIL].join(""), [].concat(standardFields, [{
  width: true
}])); //No productShape required

exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.COIL, process_models_1.CutShape.RECTANGLE].join(""), [].concat(standardFields, [{
  width: true
}])); // No productShape Required

exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.PLATE].join(""), [{
  cutShape: true
}, {
  processing: true
}, {
  finish: true
}]); // No productShape Required

exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.PLATE, process_models_1.CutShape.SQUARE].join(""), [{
  cutShape: true
}, {
  processing: true
}, {
  finish: true
}, {
  oneSide: true
}, {
  oneSideTolerance: true
}]); // No productShape Required

exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.PLATE, process_models_1.CutShape.RECTANGLE].join(""), [{
  cutShape: true
}, {
  processing: true
}, {
  finish: true
}, {
  width: true
}, {
  length: true
}, {
  widthLengthTolerance: true
}]);
exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.SHEET, process_models_1.CutShape.RECTANGLE].join(""), [{
  processing: true
}, {
  width: true
}, {
  length: true
}, {
  tolerance: true
}]);
exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.BAR, process_models_1.ProductShape.FLAT].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.BAR, process_models_1.ProductShape.HEXAGON].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.BAR, process_models_1.ProductShape.SQUARE].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.BAR, process_models_1.ProductShape.ROUND].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.EXPANDED, process_models_1.ProductShape.FLATTENED].join(""), []);
exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.EXPANDED, process_models_1.ProductShape.STANDARD].join(""), []); // no data

exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.FLOORING, process_models_1.ProductShape.OPEN_GRIP].join(""), []); // no data

exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.PIPE, process_models_1.ProductShape.ROUND].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.STRUCTURAL, process_models_1.ProductShape.ANGLE].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.STRUCTURAL, process_models_1.ProductShape.BEAM].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.STRUCTURAL, process_models_1.ProductShape.CHANNEL].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.STRUCTURAL, process_models_1.ProductShape.TEE].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.TREAD_PLATE, process_models_1.ProductShape.DIAMOND].join(""), [].concat(standardFields, [{
  width: true
}]));
exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.TUBE, process_models_1.ProductShape.RECTANGLE].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.TUBE, process_models_1.ProductShape.ROUND].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.ALUMINUM, process_models_1.Form.TUBE, process_models_1.ProductShape.SQUARE].join(""), [].concat(standardFields));
/*
    BEGIN ALLOY DATA
 */
// Any Form and NO Shape combo mapping(s)

exports.processCutData.set([process_models_1.Product.ALLOY, process_models_1.Form.PLATE].join(""), [{
  cutShape: true
}, {
  processing: true
}, {
  finish: true
}]);
exports.processCutData.set([process_models_1.Product.ALLOY, process_models_1.Form.PLATE, process_models_1.CutShape.RECTANGLE].join(""), [{
  cutShape: true
}, {
  processing: true
}, {
  finish: true
}, {
  width: true
}, {
  length: true
}, {
  widthLengthTolerance: true
}]);
exports.processCutData.set([process_models_1.Product.ALLOY, process_models_1.Form.PLATE, process_models_1.CutShape.CIRCLE].join(""), [{
  cutShape: true
}, {
  processing: true
}, {
  finish: true
}, {
  outsideDiameter: true
}, {
  outsideTolerance: true
}]);
exports.processCutData.set([process_models_1.Product.ALLOY, process_models_1.Form.PLATE, process_models_1.CutShape.RING].join(""), [{
  cutShape: true
}, {
  processing: true
}, {
  finish: true
}, {
  outsideDiameter: true
}, {
  outsideTolerance: true
}, {
  insideDiameter: true
}, {
  insideTolerance: true
}]);
exports.processCutData.set([process_models_1.Product.ALLOY, process_models_1.Form.PLATE, process_models_1.CutShape.SQUARE].join(""), [{
  cutShape: true
}, {
  processing: true
}, {
  finish: true
}, {
  oneSide: true
}, {
  oneSideTolerance: true
}]);
exports.processCutData.set([process_models_1.Product.ALLOY, process_models_1.Form.BAR, process_models_1.ProductShape.FLAT].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.ALLOY, process_models_1.Form.BAR, process_models_1.ProductShape.HEXAGON].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.ALLOY, process_models_1.Form.BAR, process_models_1.ProductShape.ROUND].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.ALLOY, process_models_1.Form.BAR, process_models_1.ProductShape.SQUARE].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.ALLOY, process_models_1.Form.TUBE, process_models_1.ProductShape.ROUND].join(""), [].concat(standardFields));
/*
    MISC
 */

exports.processCutData.set([process_models_1.Product.NICKEL, process_models_1.Form.PLATE].join(""), []);
exports.processCutData.set([process_models_1.Product.NICKEL, process_models_1.Form.BAR, process_models_1.ProductShape.ROUND].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.TOOL_STEEL, process_models_1.Form.BAR, process_models_1.ProductShape.FLAT].join(""), [{
  processing: true
}, {
  length: true
}, {
  tolerance: true
}]);
exports.processCutData.set([process_models_1.Product.TOOL_STEEL, process_models_1.Form.BAR, process_models_1.ProductShape.SQUARE].join(""), [{
  processing: true
}, {
  length: true
}, {
  tolerance: true
}]);
exports.processCutData.set([process_models_1.Product.TOOL_STEEL, process_models_1.Form.BAR, process_models_1.ProductShape.ROUND].join(""), [{
  processing: true
}, {
  length: true
}, {
  tolerance: true
}]);
exports.processCutData.set([process_models_1.Product.TOOL_STEEL, process_models_1.Form.PLATE].join(""), [{
  cutShape: true
}, {
  processing: true
}, {
  finish: true
}]);
exports.processCutData.set([process_models_1.Product.TOOL_STEEL, process_models_1.Form.PLATE, process_models_1.CutShape.RECTANGLE].join(""), [{
  cutShape: true
}, {
  processing: true
}, {
  finish: true
}, {
  width: true
}, {
  length: true
}, {
  widthLengthTolerance: true
}]);
exports.processCutData.set([process_models_1.Product.TOOL_STEEL, process_models_1.Form.PLATE, process_models_1.CutShape.SQUARE].join(""), [{
  cutShape: true
}, {
  processing: true
}, {
  finish: true
}, {
  oneSide: true
}, {
  oneSideTolerance: true
}]);
/* Brass Copper and Bronze */

exports.processCutData.set([process_models_1.Product.BRASS_COPPER_BRONZE, process_models_1.Form.SHEET].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.BRASS_COPPER_BRONZE, process_models_1.Form.BAR, process_models_1.ProductShape.FLAT].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.BRASS_COPPER_BRONZE, process_models_1.Form.BAR, process_models_1.ProductShape.HEXAGON].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.BRASS_COPPER_BRONZE, process_models_1.Form.BAR, process_models_1.ProductShape.ROUND].join(""), [].concat(standardFields));
exports.processCutData.set([process_models_1.Product.BRASS_COPPER_BRONZE, process_models_1.Form.BAR, process_models_1.ProductShape.SQUARE].join(""), [].concat(standardFields));
/*
    VALVE FITTINGS

    Note: Currently Not Used, but leave here for now


//no DATA
processCutData.set([Product.VALVES_FITTINGS, Form.BUTT_WELD, ProductShape.ELBOW].join(""), []);
//no DATA
processCutData.set([Product.VALVES_FITTINGS, Form.BUTT_WELD, ProductShape.STUB_END].join(""), []);
//no DATA
processCutData.set([Product.VALVES_FITTINGS, Form.BUTT_WELD, ProductShape.TEE].join(""), []);
//no DATA
processCutData.set(
    [Product.VALVES_FITTINGS, Form.FASTENERS, ProductShape.FLAT_WASHER].join(""),
    []
);
//no DATA
processCutData.set([Product.VALVES_FITTINGS, Form.FASTENERS, ProductShape.HEX_NUTS].join(""), []);
//no DATA
processCutData.set(
    [Product.VALVES_FITTINGS, Form.FASTENERS, ProductShape.LOCK_WASHER].join(""),
    []
);
//no DATA
processCutData.set([Product.VALVES_FITTINGS, Form.FASTENERS, ProductShape.SOCKET].join(""), []);
//no DATA
processCutData.set([Product.VALVES_FITTINGS, Form.FASTENERS, ProductShape.STUDS].join(""), []);
//no DATA
processCutData.set([Product.VALVES_FITTINGS, Form.FASTENERS, ProductShape.U_BOLT].join(""), []);
// not prodShape, no DATA
processCutData.set([Product.VALVES_FITTINGS, Form.FLANGE].join(""), []);
// not prodShape, no DATA
processCutData.set([Product.VALVES_FITTINGS, Form.NIPPLE].join(""), []);
// no DATA
processCutData.set(
    [Product.VALVES_FITTINGS, Form.PRESSURE_FITTING, ProductShape.BUSHING].join(""),
    []
);
// no DATA
processCutData.set(
    [Product.VALVES_FITTINGS, Form.PRESSURE_FITTING, ProductShape.COUPLING].join(""),
    []
);
// no DATA
processCutData.set(
    [Product.VALVES_FITTINGS, Form.PRESSURE_FITTING, ProductShape.ELBOW].join(""),
    []
);
// no DATA
processCutData.set(
    [Product.VALVES_FITTINGS, Form.PRESSURE_FITTING, ProductShape.PLUG].join(""),
    []
);
// no DATA
processCutData.set([Product.VALVES_FITTINGS, Form.PRESSURE_FITTING, ProductShape.TEE].join(""), []);

// no DATA
processCutData.set(
    [Product.VALVES_FITTINGS, Form.PRESSURE_FITTING, ProductShape.INSERT].join(""),
    []
);
// no DATA
processCutData.set([Product.VALVES_FITTINGS, Form.VALVE, ProductShape.BALL].join(""), []);

// no DATA
processCutData.set([Product.VALVES_FITTINGS, Form.VALVE, ProductShape.GATE].join(""), []);
 */